import axios from 'axios'
const API_URL = "https://blooggerr.onrender.com/blogs/"
// const API_URL = "http://localhost:8080/blogs/"

function addBlog(blogData, _headers){
    console.log("POST")
    return axios.post(API_URL, blogData, {headers: _headers})
}

function getBlogs(){
    console.log("GET")
    return axios.get(API_URL)
}

function getBlog(id, _header){
    console.log("GET")
    return axios.get(`${API_URL}${id}`, {headers: _header})
}

function likeUnlikeBlog(blogId, _headers){
    return axios.post(`${API_URL}like-unlike`, blogId, {headers: _headers})
}

function addRemoveBookmark(blogId, _headers){
    console.log(`${API_URL}bookmark-unbookmark`)
    return axios.post(`${API_URL}bookmark-unbookmark`, blogId, {headers: _headers})
}

function searchBlogs(key){
    return axios.get(`${API_URL}search/${key}`)
}

function deleteBlog(blogId, _headers){
    return axios.delete(`${API_URL}delete/${blogId}`, {headers: _headers})
}

export {addBlog, getBlogs, getBlog, likeUnlikeBlog, addRemoveBookmark, searchBlogs, deleteBlog}